import React, { useState, useEffect } from 'react';
import { Card, CardBody, Typography, Input, Button } from "@material-tailwind/react";
import axios from 'axios';
import { FaTrash, FaPlus, FaCheck, FaTimes, FaPenAlt} from 'react-icons/fa';
import { useAuth } from '../AuthContext';
const { rootUrl } = require('../../../config/config');

const InsuranceTypes = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [newName, setNewName] = useState('');
  const {user} = useAuth();
  
  // Fetch all insurance types
  const fetchTypes = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${rootUrl}/insurance/types`);
      setTypes(response.data);
      setError('');
    } catch (err) {
      setError('Failed to fetch insurance types.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  // Start editing a row
  const startEdit = (type) => {
    setEditingId(type.id);
    setEditName(type.name);
  };

  // Cancel editing
  const cancelEdit = () => {
    setEditingId(null);
    setEditName('');
  };

  // Save an edited row
  const saveEdit = async (id) => {
    try {
      await axios.put(`${rootUrl}/insurance/types/${id}`, { name: editName.toUpperCase() });
      cancelEdit();
      fetchTypes();
    } catch (err) {
      setError('Failed to update insurance type.');
    }
  };

  // Delete a type
  const deleteType = async (id) => {
    if (!window.confirm('Are you sure you want to delete this insurance type?')) return;
    try {
      await axios.delete(`${rootUrl}/insurance/types/${id}`);
      fetchTypes();
    } catch (err) {
      setError('Failed to delete insurance type.');
    }
  };

  // Add a new type
  const addType = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    try {
      await axios.post(`${rootUrl}/insurance/types`, { name: newName.toUpperCase(), input_by: user.username });
      setNewName('');
      fetchTypes();
    } catch (err) {
      setError('Failed to add insurance type.');
    }
  };

  return (
    <>
      <Card className="w-full max-w-4xl mt-6 border-t">
        <CardBody>
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">
            Insurance Types
          </h2>
          <form onSubmit={addType} className="flex mb-6">
            <Input
              type="text"
              label="New Type Name"
              value={newName}
              onChange={(e) => setNewName(e.target.value.toUpperCase())}
              className="flex-grow uppercase"
              style={{ textTransform: 'uppercase' }}
            />
            <Button
              type="submit"
              variant="gradient"
              color="blue"
              className="ml-4 flex items-center"
            >
              <FaPlus className="mr-2" /> Add
            </Button>
          </form>

          {/* Types Table */}
          {loading ? (
            <Typography>Loading...</Typography>
          ) : (
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border px-4 py-2 text-left">ID</th>
                  <th className="border px-4 py-2 text-left">Name</th>
                  <th className="border px-4 py-2 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {types.map((type) => (
                  <tr key={type.id} className="hover:bg-gray-50">
                    <td className="border px-4 py-2">{type.id}</td>
                    <td className="border px-4 py-2">
                      {editingId === type.id ? (
                        <Input
                          type="text"
                          value={editName}
                          onChange={(e) => setEditName(e.target.value.toUpperCase())}
                          size="sm"
                          className="uppercase"
                          style={{ textTransform: 'uppercase' }}
                        />
                      ) : (
                        <Typography className="uppercase">{type.name}</Typography>
                      )}
                    </td>
                    <td className="border px-4 py-2 text-center space-y-2 sm:space-y-0 sm:space-x-2">
                      {editingId === type.id ? (
                        <>
                          <Button
                           
                            onClick={() => saveEdit(type.id)}
                            className="bg-transparent shadow-none"
                          >
                            <FaCheck className="text-green-700" />
                          </Button>
                          <Button
                            
                            onClick={cancelEdit}
                            className="bg-transparent shadow-none"
                          >
                            <FaTimes className="text-orange-700" />
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                           
                            onClick={() => startEdit(type)}
                            className="bg-transparent shadow-none"
                          >
                            <FaPenAlt className="text-blue-gray-700" />
                          </Button>
                          <Button
                           
                            onClick={() => deleteType(type.id)}
                            className="bg-transparent shadow-none"
                          >
                            <FaTrash className="text-red-700" />
                          </Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default InsuranceTypes;
